/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Button, Card, Modal, Row, Col, Table, Form, Input, InputNumber } from 'antd';

import Loading from 'components/Loading';
import ReportHelper from 'helpers/ReportHelper';
import { execute } from 'helpers/QueryHelper';
import siteSettings from 'configs/siteSettings';

const layout = null;

const DetailsModal = ({ params, record, text }) => {
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const [form] = Form.useForm();

  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [results, setResults] = React.useState([]);

  const openModal = () => {
    setVisible(true);
    setLoading(true);

    const parameters = {};

    params.parameters.forEach((p) => {
      parameters[p] = record[p];
    });

    ReportHelper.Query(params.sqlCommand, parameters, params.appName).then((data) => {
      setResults(data);
      console.log(data);
      setLoading(false);
    });
  };

  return (
    <React.Fragment>
      <div style={{ width: '100%', fontWeight: '700', whiteSpace: 'nowrap', cursor: 'pointer', color: '#1890ff' }} onClick={openModal}>
        Writing
      </div>
      <Modal
        centered
        width='960px'
        title='Chấm điểm TOEIC Writting'
        visible={visible}
        // onCancel={() => {
        //   setVisible(false);
        // }}
        footer={[
          <Button
            type='primary'
            key='submit'
            onClick={() => {
              form.submit();
            }}
          >
            Lưu thông tin
          </Button>,
          <Button
            type='default'
            key='close-modal'
            onClick={() => {
              setVisible(false);
            }}
          >
            Đóng
          </Button>,
        ]}
      >
        {loading ? (
          <Loading />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '75vh' }}>
            <div style={{ flex: 1, overflowX: 'auto', paddingRight: 12 }}>
              {results.map((x, index) => {
                return (
                  <Card key={`question-${index}`} size='small' title={<div dangerouslySetInnerHTML={{ __html: x.questionHeader }}></div>} style={{ width: '100%', marginBottom: 12 }}>
                    <Row gutter={[12, 12]}>
                      <Col>
                        <div dangerouslySetInnerHTML={{ __html: x.questionContent }} />
                        <div>{x.imageUrl && <img src={`${siteSettings.domain_url_ames}${x.imageUrl}`} style={{ width: '100%' }} />}</div>
                      </Col>
                    </Row>
                    <Row gutter={[12, 12]}>
                      <Col>
                        <h4>Phần trả lời của học viên</h4>
                        <div dangerouslySetInnerHTML={{ __html: x.answer }} />
                      </Col>
                    </Row>
                  </Card>
                );
              })}
            </div>
            <div style={{ paddingTop: 12 }}>
              <Card title='Giáo viên nhập điểm & nhận xét' size='small'>
                <Form
                  {...layout}
                  form={form}
                  name='basic'
                  initialValues={{}}
                  onFinish={(values) => {
                    console.log(params);

                    const parameters = {
                      enquiryID: record.enquiryID,
                      writing: values.writing,
                      comment: values.comment,
                      nguoiChamDiem: loggedInUser.email,
                    };

                    console.log(parameters);
                    execute('p_AMES_TEST_SET_ToeicWritingAndTotalScore', parameters, 'Office')
                      .then((data) => {
                        setVisible(false);
                      })
                      .catch((error) => {
                        alert('Có lỗi khi lưu thông tin. Liên hệ AMES - IT để được hỗ trợ');
                      });
                  }}
                  // onFinishFailed={(onFinishFailed)}
                >
                  <Form.Item
                    hasFeedback
                    name='writing'
                    rules={[
                      {
                        required: true,
                        message: 'Please input writting score!',
                      },
                    ]}
                  >
                    <InputNumber min={0} max={200} placeholder='Input writting score' style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item
                    hasFeedback
                    name='comment'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your comment!',
                      },
                    ]}
                  >
                    <Input.TextArea placeholder='Input your comment' />
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
        )}
      </Modal>
    </React.Fragment>
  );
};

export const renderForm_LMS_ChamDiemToeicWriting = (params) => (text, record, index) => {
  return <DetailsModal params={params} record={record} text={text} index={index} />;
};
